import Vue from 'vue'

Vue.prototype.$image = {
    logo: {
        side: require('@/assets/logo.png'),
        wide: require('@/assets/logo_wide.png'),
        general: require('@/assets/logo_general.png'),
    },
    common: {
        connection: {
            disactivated: require('@/assets/connections/disactivated.png'),
            forbidden: require('@/assets/connections/forbidden.png'),
            vpn_disconnected: require('@/assets/connections/rdp_connected.png'),
            vpn_connected: require('@/assets/connections/vpn_connected.png'),
            rdp_connected: require('@/assets/connections/vpn_disconnected.png')
        }
    },
    login: {
        logo: require('@/assets/logo_wide.png'),
        habatan: require('@/assets/login_habatan.png'),
        background: require('@/assets/login/background.png'),
        conn_image: require('@/assets/login/conn_image.png'),
        contact_email: require('@/assets/login/contact_email.png'),
    },
    user: {
        logo: require('@/assets/logo_general.png'),
        homePc: require('@/assets/user/home_pc.png'),
        officePc: require('@/assets/user/office_pc.png'),
        icon:{
            lock: require('@/assets/user/lock.png'),
            setting: require('@/assets/user/setting.png'),
            account: require('@/assets/user/user.png'),
            lock_off: require('@/assets/user/lock_off.png'),
            setting_off: require('@/assets/user/setting_off.png'),
            account_off: require('@/assets/user/user_off.png'),
        }
    },
    tenant: {

    },
    system: {

    },
    icon: {
        on: {
            book: require('@/assets/icons/png/on/icon_book.png'),
            container: require('@/assets/icons/png/on/icon_container.png'),
            graph: require('@/assets/icons/png/on/icon_graph.png'),
            house: require('@/assets/icons/png/on/icon_house.png'),
            log: require('@/assets/icons/png/on/icon_log.png'),
            question: require('@/assets/icons/png/on/icon_question.png'),
            userList: require('@/assets/icons/png/on/icon_user_list.png'),
            userEdit: require('@/assets/icons/png/on/icon_useredit.png'),
            bullhorn: require('@/assets/icons/png/on/icon_bullhorn.png'),
        },
        off: {
            book: require('@/assets/icons/png/off/icon_book.png'),
            container: require('@/assets/icons/png/off/icon_container.png'),
            graph: require('@/assets/icons/png/off/icon_graph.png'),
            house: require('@/assets/icons/png/off/icon_house.png'),
            log: require('@/assets/icons/png/off/icon_log.png'),
            question: require('@/assets/icons/png/off/icon_question.png'),
            userList: require('@/assets/icons/png/off/icon_user_list.png'),
            userEdit: require('@/assets/icons/png/off/icon_useredit.png'),
            bullhorn: require('@/assets/icons/png/off/icon_bullhorn.png'),
        }
    }
}
